<template>
	<div class="container">
		<!--页面开始-->
		<div class="main_box">
			
			<!--滑动加载-->
			<van-list
			  v-model="hotLoading"
			  :finished="hotFinished"
			  :finished-text="noDataText"
			  loading-text="数据加载中..."
			  @load="onLoad"
			>
				<div v-for="(value, index) in testData" class="result_box" :key="index">
					<div v-if="value.two_status == 1 || value.two_status == 2" class="icon_box" @click="share(value)">
						<img src="../../assets/img/icon_share.png" />
					</div>
					<div class="top_box">
						<div class="img_box">
							<img :src="imgurl + value.image" @click="showImg(value)" />
						</div>
						<div class="txt_box">
							<div class="txt_txt">{{ value.username == '' ? '--' : value.username }}</div>
							<div class="txt_txt">
								<div class="txt_el">
									自选：
									<span v-if="value.self_status == null" style="font-size: 0.5rem;">未选择</span>
									<span v-if="value.self_status == 1" style="color: #3AD80B;font-size: 0.5rem;font-weight: bold;">阴性</span>
									<span v-if="value.self_status == 2" style="color: #ff0000;font-size: 0.5rem;font-weight: bold;">阳性</span>
									<span v-if="value.self_status == 3" style="color: #FF9100;font-size: 0.5rem;font-weight: bold;padding-right: 0.1rem;">无效</span>
								</div>
								<div v-if="value.two_status != null" class="txt_el" style="text-align: right;">
									官方：
									<!-- <span v-if="value.two_status == null" style="font-size: 0.5rem;">审核中</span> -->
									<span v-if="value.two_status == 1" style="color: #3AD80B;font-size: 0.5rem;font-weight: bold;">阴性</span>
									<span v-if="value.two_status == 2" style="color: #ff0000;font-size: 0.5rem;font-weight: bold;">阳性</span>
									<span v-if="value.two_status == 3" style="color: #FF9100;font-size: 0.5rem;font-weight: bold;padding-right: 0.1rem;">无效</span>
									<van-icon v-if="value.two_status == 3" name="question-o" size="0.4rem" color="#666666" @click="showWhy(value)" />
								</div>
							</div>
							<div class="txt_txt">
								<span>{{ initTime(value.create_time) }}</span>
								<span style="display: inline-block;padding-left: 0.3rem;">产品：{{ value.product_name }}</span>
							</div>
						</div>
					</div>
					<div class="bot_tit">
						*本检测结果可能受到采样时间、部位及方法局限性等因素影响，需结合临床分析，本条记录仅对本次检测样本负责
					</div>
					<div v-if="index != testData.length - 1" class="bot_line"></div>
				</div>	
			</van-list>
			<!--滑动加载-->
			
			<div v-if="isNoData">
				<van-empty image="search" description="暂未查询到相关记录" />
			</div>
		</div>
		<!--页面开始-->
		<!--分享海报-->
		<van-popup v-model="shareBox" style="width: 75%;">
			<div v-show="isLoad" class="share_box">
				<img :src="imgurl + shareImgUrl" />
				<div class="share_tit">
					<img src="../../assets/img/icon_download.png" />
					长按图片保存至相册
				</div>
			</div>
		</van-popup>
		<!--分享海报-->
	</div>
</template>

<script>
import { otherTestList, shareImg } from "@/api/record/index";
import { UPURL } from "@/utils/upload";
import { shareUrl } from '@/utils/wxshare'
import { ImagePreview } from 'vant';

export default {
	components:{
		//
	},
	data() {
		return {
			imgurl: '',
			testData: [],
			hotLoading: false, 
			hotFinished: false,
			pageSize: 1,  //页数
			isNoData: false,
			noDataText: '仅展示近一个月的记录，没有更多数据了～',
			shareBox: false,  //分享海报
			shareImgUrl: '',  //海报地址
			isLoad: false,
		}
	},
	created(){
		let that = this;
		if(!localStorage.getItem('token')) {
			this.$router.push({path:'/login'});
		}
		if(localStorage.getItem('token')) {
			that.imgurl = UPURL;
		}
	},
	mounted() {
		//微信分享
		let that = this;
		that.$nextTick(() => {
			shareUrl(that);
		});
	},
	watch: {
		//
	},
	methods: {
		//初始化时间
		initTime(value) {
			if(value) {
				return moment(value * 1000).format("YYYY年MM月DD日 HH:mm:ss");
			}
		},
		onLoad() {
			let that = this;
			if(that.$route.query.id) {
				that.hotOnLoad();
				that.hotLoading = true;
			}
		},
		hotOnLoad() {
			let that = this;
			//请求列表
			otherTestList({
				id: that.$route.query.id,
				page: that.pageSize,
				page_size: 5,
			}).then(res => {
				if(that.pageSize == 1 && res.data.data.length <= 0) {
					that.noDataText = '';
					that.isNoData = true;
				}
				that.hotLoading = false;
				that.testData = that.testData.concat(res.data.data);
				that.pageSize++;
				// 如果加载完毕，显示没有更多了
				if (res.data.data.length == 0) {
					that.hotFinished = true;
				}
			});
		},
		//分享
		share(value) {
			let that = this;
			that.$toast.loading({
				message: '生成中...',
				forbidClick: true,
				duration: 0,
			});
			//生成海报
			shareImg({id: value.id}).then(res => {
				that.shareImgUrl = res.data;
				that.isLoad = false;
				that.shareBox = true;
				that.$toast.clear();
				that.$nextTick(function(){
					setTimeout(() => {
						that.isLoad = true;
					}, 800);
				});
			});
		},
		//无效原因
		showWhy(value) {
			let that = this;
			that.$toast('无效原因：' + value.remark);
		},
		//查看大图
		showImg(value) {
			let that = this;
			ImagePreview({
				images: [that.imgurl + value.image],
				showIndex: false,
			});
		}
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.main_box{
	width: 100%;
	min-height: 100vh;
	padding-top: 0.2rem;
}

/*分享海报*/
.share_box{
	position: relative;
}
.share_box img{
	width: 100%;
}
.share_box .share_tit{
	width: 100%;
	position: absolute;
	bottom: 0.22rem;
	color: #ffffff;
	font-size: 0.32rem;
	text-align: center;
}
.share_box .share_tit img{
	position: relative;
	top: 0.05rem;
	margin-right: 0.1rem;
	width: 0.32rem;
	height: auto;
}

/*检测记录*/
.result_box{
	position: relative;
	margin-bottom: 0.15rem;
}
.result_box .icon_box{
	position: absolute;
	right: 0.3rem;
	top: 0.2rem;
}
.result_box .icon_box img{
	width: 0.4rem;
}
.result_box .bot_line{
	width: 100%;
	border-top: 0.1rem solid #F5F6F7;
}
.top_box{
	display: flex;
	padding: 0.4rem 0.4rem 0.25rem 0.4rem;
}
.top_box .img_box{
	display: flex;
    align-items: center;
    justify-content: center;
	width: 1.8rem;
	height: 2.4rem;
	background-color: #CECECE;
	text-align: center;
	border-radius: 0.15rem;
	overflow: hidden;
}
.top_box .img_box img{
	width: auto;
	max-width: 100%;
	height: auto;
	max-height: 100%;
}
.top_box .txt_box{
	flex: 4;
	padding-left: 0.5rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	/* margin-right: 0.5rem; */
}
.top_box .txt_box .txt_txt{
	padding-top: 0.26rem;
	color: #333333;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.txt_box .txt_txt span{
	font-size: 0.32rem;
}
.top_box .txt_box .txt_txt:first-child{
	padding-top: 0;
}
.txt_box .txt_txt{
	display: flex;
}
.txt_box .txt_txt .txt_el{
	flex: 1;
}
.txt_box .txt_txt .txt_el:last-child{
	
}
.bot_tit{
	padding: 0rem 0.4rem 0.2rem 0.4rem;
	font-size: 0.32rem;
	color: #999999;
}

</style>
